// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"5329":"da8a2fe7","9808":"8ba01f2f"}[chunkId] + ".css";
};